import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import React, { useState, useCallback, useRef } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { Alert } from "@material-ui/lab";
import Webcam from "react-webcam";

export const DialogDelete = ({ handleDelete, handleClose, deleteFile }) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Dialog
            style={{ margin: "auto" }}
            PaperProps={{
                style: {
                    borderRadius: "20px",
                    maxWidth: "unset"
                }
            }}
            open
            onClose={!isLoading ? handleClose : () => { }}>
            <DialogContent
                style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: "450px" }}>
                <Box
                    style={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme => theme.palette.grey[500]
                    }}>
                    <IconButton aria-label="close" disabled={isLoading} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <DialogTitle style={{ width: "100%", paddingLeft: "0px" }}>
                    Er du sikker på du vil slette billedet?
                </DialogTitle>
                <DialogContentText>Denne handling er permanent og kan ikke fortrydes efterførlgende</DialogContentText>
                <img src={deleteFile.imageUrl} className="thumb_img" alt={deleteFile.imageName} />
                <DialogActions
                    style={{
                        justifyContent: "space-between",
                        width: "100%",
                        margin: "20px 0px",
                        gap: "10px"
                    }}>
                    <Button
                        disabled={isLoading}
                        style={{
                            backgroundColor: "#D61C1C",
                            borderRadius: "6px",
                            width: "100%",
                            color: "white",
                            padding: "8px",
                            ...(isLoading && { opacity: 0.5 })
                        }}
                        onClick={async () => {
                            setIsLoading(true);
                            await handleDelete();
                        }}>
                        {isLoading && <CircularProgress color="primary" style={{ height: "20px", width: "20px", marginRight: '5px' }} />}
                        Slet
                    </Button>
                    {/* delete */}
                    <Button
                        disabled={isLoading}
                        style={{
                            border: "1px solid #0B54B3",
                            borderRadius: "6px",
                            width: "100%",
                            padding: "8px"
                        }}
                        onClick={handleClose}>
                        Anullér
                    </Button>
                    {/* cancel */}
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export const DialogImage = ({ imageFile, handleClose }) => {
    return (
        <Dialog
            style={{ margin: "auto" }}
            PaperProps={{
                style: {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    width: "100%",
                    height: "auto",
                },
            }}
            open
            onClose={() => handleClose()}>
            <DialogContent
                style={{
                    display: "flex",
                    position: "relative",
                    width: "100%",
                    maxWidth: "800px",
                    padding: "24px",
                    margin: "0px auto",
                }}>
                <img
                    src={imageFile}
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                        display: "block",
                        margin: "0px auto"
                    }}
                    alt={"img"}
                />
                <CloseIcon
                    style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        color: "white",
                        cursor: "pointer",
                    }}
                    onClick={() => handleClose()}
                />
            </DialogContent>
        </Dialog>
    );
};

export const DialogDownload = ({
    downloadData,
    isImageLoading,
    handleOnImageClick,
    handleDownloadData,
    handleCloseDownload
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    return (
        <Dialog
            style={{ margin: "auto" }}
            PaperProps={{
                style: {
                    borderRadius: "10px",
                    maxWidth: "unset"
                }
            }}
            open
            onClose={!isLoading && handleCloseDownload}>
            <DialogContent
                style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: "1250px" }}>
                <Box
                    style={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme => theme.palette.grey[500]
                    }}>
                    <IconButton aria-label="close" onClick={!isLoading && handleCloseDownload}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <DialogTitle style={{ width: "100%", paddingLeft: "0px", paddingRight: "30px" }}>
                    {(isImageLoading || downloadData.length > 0) ? "Download billeder fra patientjournalen" : "Ingen billeder fundet"}
                </DialogTitle>
                {!isImageLoading ? (
                    <>
                        {downloadData.length > 0 ? (
                            <>
                                <DialogContentText style={{ width: "100%", paddingLeft: "0px" }}>
                                    klik for at vælge billeder til download
                                </DialogContentText>
                                <div className="thumbs_container_download">
                                    {downloadData.map(file => (
                                        <div
                                            key={file.imageName}
                                            style={{
                                                position: "relative",
                                                aspectRatio: "3/4",
                                                boxSizing: "border-box",
                                                cursor: 'pointer'
                                            }}
                                            onClick={e => {
                                                e.preventDefault();
                                                !isLoading && handleOnImageClick(file.imageName);
                                            }}>
                                            <img
                                                src={file.imageUrl}
                                                style={{
                                                    border: "1px solid rgba(0,0,0,0.2)",
                                                    ...(file.isChecked && {
                                                        borderColor: '#0b54b3',
                                                        overflow: "hidden",
                                                    })
                                                }}
                                                className="thumb_img"
                                                alt={file.imageName}
                                            />
                                            <div
                                                className="check_button"
                                                style={{
                                                    position: "absolute",
                                                    top: 4,
                                                    right: 4
                                                }}>
                                                {file.isChecked && (
                                                    <CheckCircleIcon style={{ color: "#0b54b3" }} />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="thumbs_container_download" style={{ textAlign: "center", maxWidth: "360px" }}>
                                    Der er ingen billeder tilgængelige til download.
                                    <br />
                                    Hvis du har uploadet billeder, men ikke kan downloade dem her,
                                    så prøv at tjekke, om de ligger i din Google Drive.
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <>
                        <div className="thumbs_container_download" style={{ alignItems: "center", width: "15rem", height: "10rem" }}>
                            <CircularProgress />
                        </div>
                    </>
                )}

                {error && (
                    <Alert severity="warning" style={{ marginTop: "5px", width: '100%' }} onClose={() => setError('')}>
                        {error}
                    </Alert>
                )}
                <DialogActions
                    style={{
                        width: "100%",
                        margin: "20px 0px",
                        gap: "10px",
                        justifyContent: "flex-start"
                    }}>
                    {(isImageLoading || downloadData.length > 0) ? (
                        <>
                            <Button
                                disabled={isLoading || (downloadData.length === 0)}
                                style={{
                                    backgroundColor: "#0B54B3",
                                    borderRadius: "6px",
                                    color: "white",
                                    padding: "8px",
                                    ...((isLoading || (downloadData.length === 0)) && { opacity: 0.5 })
                                }}
                                onClick={async () => {
                                    setIsLoading(true);
                                    if (downloadData.filter(file => file.isChecked).length > 0) {
                                        await handleDownloadData();
                                    } else {
                                        setError('Please select Image for Download');
                                    }
                                    setIsLoading(false);
                                }}
                            >
                                {isLoading && <CircularProgress color="success" style={{ height: "20px", width: "20px", marginRight: '5px' }} />}
                                Download
                            </Button>
                            {/* Download */}
                            <Button
                                disabled={isLoading || (downloadData.length === 0)}
                                style={{
                                    border: "1px solid #0B54B3",
                                    borderRadius: "6px",
                                    padding: "8px",
                                    ...((isLoading || (downloadData.length === 0)) && { opacity: 1 })
                                }}
                                onClick={() => handleCloseDownload()}>
                                Anullér
                            </Button>
                            {/* cancel */}
                        </>
                    ) : (
                        <>
                            <Button
                                disabled={isLoading}
                                style={{
                                    backgroundColor: "#0B54B3",
                                    borderRadius: "6px",
                                    color: "white",
                                    padding: "8px",
                                }}
                                onClick={handleCloseDownload}
                            >
                                Ok
                            </Button>
                        </>
                    )}
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

const videoConstraints = {
    width: 400,
    facingMode: "environment"
};

export const DialogCaptureImage = ({ handleClose, captureCameraImage }) => {
    const webcamRef = useRef(null);

    const [isError, setIsError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [url, setUrl] = useState(null);

    const capturePhoto = useCallback(async () => {
        const imageSrc = webcamRef.current.getCanvas();
        imageSrc.toBlob((blob) => {
            captureCameraImage(blob);
        });
        handleClose();
    }, [webcamRef]);

    const onUserMedia = (e) => {
        console.log(e);
    };
    const onUserMediaError = (e) => {
        console.log(e);
        setIsError(e);
    }
    return <Dialog
        style={{ margin: "auto" }}
        PaperProps={{
            style: {
                borderRadius: "20px",
                maxWidth: "unset"
            }
        }}
        open
        onClose={!isLoading ? handleClose : () => { }}>
        <DialogContent
            style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: "450px" }}>
            <Box
                style={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme => theme.palette.grey[500]
                }}>
                <IconButton aria-label="close" disabled={isLoading} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogTitle style={{ width: "100%", paddingLeft: "0px" }}>
                Capture Image
            </DialogTitle>
            {isError ? (
                <>
                    <p>{isError.toString()}</p>
                </>
            ) : (
                <Webcam
                    ref={webcamRef}
                    // audio={true}
                    mirrored
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                    onUserMedia={onUserMedia}
                    onUserMediaError={onUserMediaError}
                />
            )}
            <DialogActions
                style={{
                    justifyContent: "space-between",
                    width: "100%",
                    margin: "20px 0px",
                    gap: "10px"
                }}>
                <Button
                    disabled={isLoading || isError}
                    style={{
                        backgroundColor: "#0B54B3",
                        borderRadius: "6px",
                        width: "100%",
                        color: "white",
                        padding: "8px",
                        ...((isLoading || isError) && { opacity: 0.5 })
                    }}
                    onClick={async () => {
                        setIsLoading(true);
                        await capturePhoto();
                    }}>
                    {isLoading && <CircularProgress color="primary" style={{ height: "20px", width: "20px", marginRight: '5px' }} />}
                    Capture
                </Button>
                {/* delete */}
                <Button
                    disabled={isLoading}
                    style={{
                        border: "1px solid #0B54B3",
                        borderRadius: "6px",
                        width: "100%",
                        padding: "8px"
                    }}
                    onClick={handleClose}>
                    Anullér
                </Button>
                {/* cancel */}
            </DialogActions>
        </DialogContent>
    </Dialog>
}